import { render } from "./GenealogyTable.vue?vue&type=template&id=56f782d8&scoped=true&ts=true"
import script from "./GenealogyTable.vue?vue&type=script&lang=ts"
export * from "./GenealogyTable.vue?vue&type=script&lang=ts"

import "./GenealogyTable.vue?vue&type=style&index=0&id=56f782d8&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f782d8"]])

export default __exports__